// extracted by mini-css-extract-plugin
module.exports = {"benefitItem":"HeroBenefits_benefitItem__2hRZD","image":"HeroBenefits_image__-kELZ","benefits":"HeroBenefits_benefits__2l_sG"};